function doIndents(str) {
  return str.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})(.*)/, '+7 $2 $3-$4-$5');
}

export default {
  bind(el, binding) {
    const $el = el;
    if (binding.value) {
      $el.innerHTML = doIndents(binding.value);
    } else {
      $el.innerHTML = doIndents(binding.expression);
    }
  },
  update(el, binding) {
    const $el = el;
    if (binding.value) {
      $el.innerHTML = doIndents(binding.value);
    } else {
      $el.innerHTML = doIndents(binding.expression);
    }
  },
};
